export class Pollsandsurvey {
  searchText: string;
  name: string;
  parkid: string;
  buildingid: string;
  tenantid: string;
  surveytype: string;
  startdate: any;
  enddate: any;
  eventid: string;
  couponTitle: string;
  couponId: string;
  question: string;
  questionType: string;
  questionText: string;
  answerText: string;
  questionId: string;
  reminderMessage: string;
  buldingIdMultiple: any;
  tenantIdMultiple: any;
  parkIdMultiple: any;
}
